export default "__VITE_ASSET__BWq1bLRV__"